




















































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import _ from "lodash";
import Util from "../../../lib/util";
import Address from "../../../store/entities/address";
import AddressModal from "../../components/address-modal.vue";
import moment from "moment";

@Component({
  components: { AddressModal },
})
export default class UpdateWarrantyActivation extends AbpBase {
  @Prop({ type: Boolean, default: false })
  value: boolean;
  @Prop({ type: String, default: "" }) hiddenCode: string;
  spinShow: boolean = false;
  namespace = "warrantyActivation";
  collectionCode: any = {};
  selectedAddress: Address = new Address();
  addressModalShow: boolean = false;
  validFullAddress = false;
  async getCollectionCode() {
    await this.$store
      .dispatch({
        type: `${this.namespace}/get`,
        data: {
          hiddenCode: this.hiddenCode,
        },
      })
      .then((result) => {
        this.collectionCode = result;
        if (!_.isNil(this.collectionCode.warrantyDate)) {
          this.collectionCode.warrantyDate = moment(
            this.collectionCode.warrantyDate
          ).toDate();
        }
        if (!_.isNil(this.collectionCode.consumerPurchaseDate)) {
          this.collectionCode.consumerPurchaseDate = moment(
            this.collectionCode.consumerPurchaseDate
          ).toDate();
        }
      });
  }
  updateAddress() {
    if (!Util.isNull(this.selectedAddress)) {
      this.collectionCode.consumerFullAddress = this.selectedAddress.fullAddress;
      this.collectionCode.consumerProvinceId = this.selectedAddress.provinceId;
      this.collectionCode.consumerDistrictId = this.selectedAddress.districtId;
      this.collectionCode.consumerWardId = this.selectedAddress.wardId;
    } else {
      this.collectionCode.consumerFullAddress = "";
      this.collectionCode.consumerProvinceId = null;
      this.collectionCode.consumerDistrictId = null;
      this.collectionCode.consumerWardId = null;
    }
  }
  openModalAddress() {
    this.addressModalShow = true;
  }
  reset() {
    this.collectionCode = {};
    this.selectedAddress = new Address();
    this.validFullAddress = false;
  }
  callbackCheckFullAddress() {
    this.validFullAddress = true;
  }
  save() {
    (this.$refs.updateWarrantyActivationForm as any).validate(
      async (valid: boolean) => {
        if (valid) {
          this.validateFullAddress(
            this.updateRules,
            "",
            this.callbackCheckFullAddress
          );
          if (this.validFullAddress) {
            this.$Modal.confirm({
              title: this.L("Tips"),
              content: this.L("Confirm.UpdateWarrantyActivation"),
              okText: this.L("Yes"),
              cancelText: this.L("No"),
              onOk: () => {
                this.spinShow = true;
                this.$store
                  .dispatch({
                    type: "warrantyActivation/update",
                    data: {
                      hiddenCode: this.collectionCode.hiddenCode,
                      warrantyDate: this.collectionCode.warrantyDate,
                      consumerPurchaseDate: this.collectionCode
                        .consumerPurchaseDate,
                      consumerName: this.collectionCode.consumerName,
                      consumerPhone: this.collectionCode.consumerPhone,
                      consumerEmail: this.collectionCode.consumerEmail,
                      consumerIdentityCard: this.collectionCode
                        .consumerIdentityCard,
                      warrantyActivateNote: this.collectionCode
                        .warrantyActivateNote,
                      consumerFullAddress: this.collectionCode
                        .consumerFullAddress,
                      consumerProvinceId: this.collectionCode.consumerProvinceId,
                      consumerDistrictId: this.collectionCode.consumerDistrictId,
                      consumerWardId: this.collectionCode.consumerWardId
                    },
                  })
                  .then(() => {
                    Util.showSuccessMsg(
                      this,
                      "Success.UpdateWarrantyActivation"
                    );
                    this.reset();
                    (this.$refs
                      .updateWarrantyActivationForm as any).resetFields();
                    this.$emit("input", false);
                  })
                  .finally(() => {
                    this.spinShow = false;
                  });
              },
            });
          }
        }
      }
    );
  }
  cancel() {
    this.reset();
    (this.$refs.updateWarrantyActivationForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.getCollectionCode();
    }
  }
  created() {}
  validateFullAddress(rule, value, callback) {
    if (
      _.isNil(this.collectionCode.consumerFullAddress) ||
      _.isEmpty(this.collectionCode.consumerFullAddress)
    ) {
      callback(
        new Error(this.L("Error.RequiredField0", undefined, this.L("Address")))
      );
    } else {
      callback();
    }
  }
  updateRules = {
    warrantyDate: [
      {
        required: true,
        type: "date",
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("WarrantyDate")
        ),
        trigger: "blur",
      },
    ],
    consumerFullAddress: [
      {
        required: true,
        validator: this.validateFullAddress,
        trigger: "change",
      },
    ],
    consumerPurchaseDate: [
      {
        required: true,
        type: "date",
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("ConsumerPurchaseDate")
        ),
        trigger: "blur",
      },
    ],
    consumerName: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("ConsumerName")
        ),
        trigger: "blur",
      },
    ],
    consumerPhone: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("ConsumerPhone")
        ),
        trigger: "blur",
      },
    ],
  };
}
